// constants
export const OFFER_PROPERTIES = {
  OFFER_TITLE: 'Offers',
  COUPON_TITLE: 'Coupons',
  AVAILABLE_TEXT: 'available',
  LOGO_HEIGHT: 40,
  LOGO_WIDTH: 40,
  PREVIEW_LOGO_WIDTH: 64,
  PREVIEW_LOGO_HEIGHT: 64,
  DESCRIPTION_LENGTH_DESKTOP: 40,
  DESCRIPTION_LENGTH_MOBILE: 35,
};

// constants
export const DefaultApiData = {
  coupons: [],
  offers: [],
  tradeOffers: [],
  paymentOffers: [],
  bestOffers: [],
  bestOfferMessage: '',
  offerBestPrice: 0,
  bestOfferIdentifier: 0,
  bestOfferTotalDiscount: 0,
  productId: '0',
  fetching: true,
};

export enum API_STATUS {
  SUCCESS,
  FAILURE,
  IDLE,
}
